const TestMenus = [
  {
    name: "Monthly",
    submenus: [ {name: '2.1', link:'/Monthly/2.1'},
                {name: '2.1a', link:'/Monthly/2.1a'},              
              ]
  },
  {
    name: "Quarterly",
    submenus: [ {name: '2.1', link:'/Monthly/2.1'},
                {name: '2.1a', link:'/Monthly/2.1a'},
                {name: '2.2a', link:'/Quaterly/2.2a'},
                {name: '2.2b', link:'/Quaterly/2.2b'},
                {name: '2.5', link:'/Quaterly/2.5'},   
                /*{name: '2.6', link:'/Semi-Annually/2.6'},   */     
              ]
  },
  {
    name: "Semi-Annual",
    submenus: [ {name: '1.4', link:'/Semi-Annually/1.4'},
                {name: '2.1', link:'/Monthly/2.1'},
                {name: '2.1a', link:'/Monthly/2.1a'},
                {name: '2.2a', link:'/Quaterly/2.2a'},
                {name: '2.2b', link:'/Quaterly/2.2b'},
                {name: '2.5', link:'/Quaterly/2.5'}, 
                /*{name: '2.6', link:'/Semi-Annually/2.6'},*/              
              ]
  },
  {
    name: "Annual",
    submenus: [ {name: '1.4', link:'/Semi-Annually/1.4'},
                {name: '2.1', link:'/Monthly/2.1'},
                {name: '2.1a', link:'/Monthly/2.1a'},
                {name: '2.2a', link:'/Quaterly/2.2a'},
                {name: '2.2b', link:'/Quaterly/2.2b'},
                {name: '2.5', link:'/Quaterly/2.5'}, 
                /*{name: '2.6', link:'/Semi-Annually/2.6'},*/
                {name: '3.2', link:'/Annually/3.2'},
                {name: '7.3', link:'/Annually/7.3'},              
              ]
  },
  {
    name: "Admin Export",
    submenus: [ {name: 'Monthly', link:'/Export/Monthly'},
                {name: 'Quarterly', link:'/Export/Quaterly'},
                {name: 'Semi-Annually', link:'/Export/Semi-Annually'},
                {name: 'Annually', link:'/Export/Annually'},            
              ]
  },
  {
    name: 'Export All', link:'/'
  },
  {
    name: 'Data Lookup', link:'/'
  }
]

export default TestMenus;